/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSportsTennisIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-sports-tennis"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M13.05 15.05Q10.2 15.05 9.14 15.28Q8.07 15.5 7.28 16.3L4.08 19.5Q3.7 19.88 3.16 19.88Q2.63 19.88 2.23 19.5Q1.82 19.13 1.81 18.57Q1.8 18.02 2.2 17.63L5.38 14.45Q6.17 13.68 6.42 12.54Q6.67 11.4 6.67 8.63Q6.67 7.1 7.36 5.61Q8.05 4.13 9.35 2.8Q11.85 0.3 14.93 0Q18 -0.3 19.98 1.73Q21.95 3.77 21.64 6.84Q21.32 9.9 18.9 12.32Q17.55 13.68 16.06 14.36Q14.57 15.05 13.05 15.05ZM10.15 11.47Q11.35 12.68 13.39 12.36Q15.43 12.05 17.05 10.45Q18.68 8.82 19 6.81Q19.32 4.8 18.13 3.6Q16.88 2.4 14.9 2.69Q12.93 2.98 11.28 4.6Q9.65 6.22 9.31 8.26Q8.97 10.3 10.15 11.47ZM18.02 23.68Q18.02 23.68 17.05 23.68Q16.07 23.68 14.7 22.3Q13.32 20.93 13.32 18.98Q13.32 17.02 14.7 15.65Q16.07 14.28 18.02 14.28Q19.98 14.28 21.35 15.65Q22.73 17.02 22.73 18.98Q22.73 20.93 21.35 22.3Q19.98 23.68 18.02 23.68Z" fill={color} />
    </svg>
  );
}
